var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('base-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('admin.dashboard.historyComponnent.title')))]),_c('v-card-text',[(_vm.loaded)?_c('apexchart',{attrs:{"type":"area","height":"300","options":_vm.marketChart.chartOptions,"series":_vm.marketChart.series}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }